import Api from "..";
import { endPoints, requestType } from "../../constants/Variables";

const getUserNotification = (id, typeee) => {
  return Api(
    `${endPoints.getUserNotification}?userId=${id}&userType=${typeee}`,
    null,
    requestType.GET
  );
};

const markNotificationRead = (id) => {
  return Api(`${endPoints.markReadNotification}/${id}`, null, requestType.PUT);
};

export { getUserNotification, markNotificationRead };
